import React, { useState, useEffect } from 'react';
import { CustomButton, GroupView } from '../../../artboard/Toolbar/styles';
import { Col, Row, Tooltip } from 'antd';
import { lineHeights } from '../../../utils/editor/fonts';
import { TEXT_AREA_TOOLBAR } from '../../../artboard/Toolbar/translationValues';
import { SpacingIcon } from '../../../images/TextBlockIcons';
import styled from 'styled-components';

const GroupViewStyle = styled(GroupView)`
  left: auto;
  right: 0 !important;
  .ql-picker-label[data-label]:not([data-label=''])::before {
    content: attr(data-label);
  }

  .ql-align .ql-picker-label svg {
    width: 25px;

    .ql-stroke {
      stroke: #444 !important;
    }
  }

  .ql-picker-item .ql-stroke {
    stroke: #444 !important;
  }

  .ql-picker-options {
    text-align: -webkit-center;
  }

  .ql-snow.ql-toolbar .ql-letterspace span.ql-picker-label:hover {
    color: grey !important;
  }
`;

export const RenderSpacing = ({ t, itemUUID }) => {
  const [showAlignment, setShowAlignment] = useState(false);

  const toggleAlignment = value => {
    setShowAlignment(value);
  };

  const checkClicks = (e, selector, callback) => {
    let targetElement = e.target;
    do {
      if (targetElement === selector) {
        return;
      }
      targetElement = targetElement.parentNode;
    } while (targetElement);
    callback();
  };

  const handleClicks = e => {
    const lineHeightSelector = document.querySelector(`#toolbar-${itemUUID} #spacing-ref`);

    checkClicks(e, lineHeightSelector, () => {
      if (showAlignment) toggleAlignment(false);
    });
  };

  useEffect(() => {
    document.addEventListener('click', handleClicks);
    return () => {
      document.removeEventListener('click', handleClicks);
    };
    // eslint-disable-next-line
  }, [showAlignment]);

  useEffect(() => {
    setShowAlignment(false);
  }, []);

  return (
    <span style={{ position: 'relative' }}>
      <Tooltip
        placement="top"
        title={t(
          TEXT_AREA_TOOLBAR.TEXT_SPACING_TOOLTIP.key,
          TEXT_AREA_TOOLBAR.TEXT_SPACING_TOOLTIP.value,
        )}
      >
        <CustomButton
          className="custom-picker ql-format-style"
          onClick={() => toggleAlignment(!showAlignment)}
        >
          <SpacingIcon />
        </CustomButton>
      </Tooltip>
      <GroupViewStyle
        className="ql-formats"
        id="spacing-ref"
        style={{ display: showAlignment ? 'block' : 'none', width: '250px' }}
      >
        <Row gutter={[16, 16]} justify="center">
          <Col span={16}>
            {t(
              TEXT_AREA_TOOLBAR.TEXT_LINE_HEIGHT_LABEL.key,
              TEXT_AREA_TOOLBAR.TEXT_LINE_HEIGHT_LABEL.value,
            )}
          </Col>
          <Col span={8}>
            <select
              className="ql-lineheight"
              onChange={e => e.persist()}
              style={{ width: 80, color: 'black' }}
            >
              {lineHeights.map((value, index) => (
                <option key={index} value={parseFloat(value) + 'em'}>
                  {value}
                </option>
              ))}
            </select>
          </Col>
        </Row>
        <Row gutter={[16, 16]} justify="center">
          <Col span={16}>
            {t(
              TEXT_AREA_TOOLBAR.TEXT_LETTER_SPACING_LABEL.key,
              TEXT_AREA_TOOLBAR.TEXT_LETTER_SPACING_LABEL.value,
            )}
          </Col>
          <Col span={8}>
            <select
              className="ql-letterspace"
              onChange={e => e.persist()}
              style={{ width: 80, color: 'black' }}
            >
              <option value={'0px'}>{0}</option>
              {lineHeights.map((value, index) => (
                <option key={index} value={parseFloat(value) + 'px'}>
                  {value}
                </option>
              ))}
            </select>
          </Col>
        </Row>
        <Row gutter={[16, 16]} justify="center">
          <Col span={16}>
            {t(
              TEXT_AREA_TOOLBAR.TEXT_ALIGNMENT_LABEL.key,
              TEXT_AREA_TOOLBAR.TEXT_ALIGNMENT_LABEL.value,
            )}
          </Col>
          <Col span={8} style={{ textAlign: 'center' }}>
            <span className="ql-formats ql-custom-tray">
              <select className="ql-align" defaultValue={''} style={{ width: 120, color: 'black' }}>
                <option value="" />
                <option value="center" />
                <option value="right" />
                <option value="justify" />
              </select>
            </span>
          </Col>
        </Row>
      </GroupViewStyle>
    </span>
  );
};
